import React, { useContext, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { ProductDetailsContext } from '../../../context';
import { Button } from 'ui-components/components/button';
import { Alias } from './alias';
import { messages } from './messages';

import style from '../../../style.module.less';
import aliasStyle from './style.module.less';

export const Aliases = () => {
  const { productId, productAliases, setProductAliases } = useContext(ProductDetailsContext);

  const onDeleteAlias = useCallback(
    (productAliasId) => {
      setProductAliases(productAliases.filter((alias) => alias.productAliasId !== productAliasId));
    },
    [productAliases, setProductAliases],
  );
  // oxlint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const newAlias = {
    storeGuid: undefined,
    aliasSKU: '',
    isNewAlias: true,
    productId,
    productAliasId: productAliases.length + 1,
  };

  const onAddAlias = useCallback(() => {
    const newAliases = [...productAliases, newAlias];
    setProductAliases(newAliases);
    // oxlint-disable-next-line react-hooks/exhaustive-deps -- newAlias changes every render
  }, [setProductAliases, productAliases, newAlias]);

  return (
    <>
      <div className={style['shipping-defaults-header-wrapper']}>
        <div className={style['shipping-defaults-header-text']}>
          <FormattedMessage {...messages.aliasesTitle} />
        </div>
      </div>
      <div className={style['defaults-info-message']}>
        <FormattedMessage {...messages.aliasesDefaultsSubHeader} />
      </div>
      <div className={style['aliases-options']}>
        {productAliases.length > 0 && (
          <div className={aliasStyle['alias-header']}>
            <div className={aliasStyle['alias-header-sku']}>
              <FormattedMessage {...messages.aliasHeaderSku} />
            </div>
            <div className={aliasStyle['alias-header-store']}>
              <FormattedMessage {...messages.aliasHeaderStore} />
            </div>
          </div>
        )}
        <div className={aliasStyle['store-alias-list']}>
          {productAliases.length === 0 && (
            <div className={aliasStyle['alias-list-empty']}>
              <FormattedMessage {...messages.aliasesEmptyList} />
            </div>
          )}
          {productAliases.map((alias) => (
            <Alias key={alias.productAliasId} alias={alias} onDeleteAlias={onDeleteAlias} />
          ))}
          <div className={aliasStyle['alias-add-button']}>
            <Button onClick={onAddAlias} theme='secondary'>
              <FormattedMessage defaultMessage='Add Alias' description='Alias Deletion Modal Add Alias' id='OLC50Y' />
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};
